
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("hDZiK"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("hDZiK", function(module, exports) {

let $cd85a15f18cf03cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cd85a15f18cf03cf$var$load("h3ABO"),
    $cd85a15f18cf03cf$var$load("djHM5"),
    $cd85a15f18cf03cf$var$load("eJQji"),
    $cd85a15f18cf03cf$var$load("2YffH"),
    $cd85a15f18cf03cf$var$load("6mHrv"),
    $cd85a15f18cf03cf$var$load("awWN9"),
    $cd85a15f18cf03cf$var$load("9CYct"),
    $cd85a15f18cf03cf$var$load("bRKjd"),
    $cd85a15f18cf03cf$var$load("ap5Gz"),
    $cd85a15f18cf03cf$var$load("hZtKG"),
    $cd85a15f18cf03cf$var$load("iNmaF"),
    $cd85a15f18cf03cf$var$load("lVO3w"),
    $cd85a15f18cf03cf$var$load("hyzoX"),
    $cd85a15f18cf03cf$var$load("h9Ed7"),
    $cd85a15f18cf03cf$var$load("eBRUf"),
    $cd85a15f18cf03cf$var$load("b2zxR"),
    $cd85a15f18cf03cf$var$load("tKhaz"),
    $cd85a15f18cf03cf$var$load("gDh1a"),
    $cd85a15f18cf03cf$var$load("ardXl"),
    $cd85a15f18cf03cf$var$load("cD6Zr"),
    $cd85a15f18cf03cf$var$load("dtASV"),
    $cd85a15f18cf03cf$var$load("9ZGcX"),
    $cd85a15f18cf03cf$var$load("9wzNh"),
    $cd85a15f18cf03cf$var$load("8YSo7"),
    $cd85a15f18cf03cf$var$load("3Zfzp"),
    $cd85a15f18cf03cf$var$load("Wowvf"),
    $cd85a15f18cf03cf$var$load("9ldRJ"),
    $cd85a15f18cf03cf$var$load("9anPW"),
    $cd85a15f18cf03cf$var$load("50ame"),
    $cd85a15f18cf03cf$var$load("3WB19"),
    $cd85a15f18cf03cf$var$load("1MlIV"),
    $cd85a15f18cf03cf$var$load("g9CVe"),
    $cd85a15f18cf03cf$var$load("7oiUM"),
    $cd85a15f18cf03cf$var$load("8t3po"),
    $cd85a15f18cf03cf$var$load("855o0"),
    $cd85a15f18cf03cf$var$load("8MfZE"),
    $cd85a15f18cf03cf$var$load("hv4mn"),
    $cd85a15f18cf03cf$var$load("dYtBN"),
    $cd85a15f18cf03cf$var$load("6wr18"),
    $cd85a15f18cf03cf$var$load("kjZZD"),
    $cd85a15f18cf03cf$var$load("2zxmz"),
    $cd85a15f18cf03cf$var$load("7269o"),
    $cd85a15f18cf03cf$var$load("jjLHK"),
    $cd85a15f18cf03cf$var$load("cxoS1"),
    $cd85a15f18cf03cf$var$load("37ldp"),
    $cd85a15f18cf03cf$var$load("ffEVr"),
    $cd85a15f18cf03cf$var$load("dRpV3"),
    $cd85a15f18cf03cf$var$load("dTsOE"),
    $cd85a15f18cf03cf$var$load("hhss7"),
    $cd85a15f18cf03cf$var$load("jwTn5"),
    $cd85a15f18cf03cf$var$load("aYdgM"),
    $cd85a15f18cf03cf$var$load("jY21r"),
    $cd85a15f18cf03cf$var$load("klApM"),
    $cd85a15f18cf03cf$var$load("eQgf0"),
    $cd85a15f18cf03cf$var$load("8fMw3"),
    $cd85a15f18cf03cf$var$load("hogcU"),
    $cd85a15f18cf03cf$var$load("74vOE"),
    $cd85a15f18cf03cf$var$load("7EorR"),
    $cd85a15f18cf03cf$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.87674fad.js.map
